/// <reference path="../../setup/_references.ts" />
module onvio.reports.firmManagementReports {
    'use strict';
    export interface ReportRequestJob {
        jobId: string,
        reportRequest: ReportRequest
    }
    export class CloudEvent {

        constructor() {

        }

        public comtrbluemoonchainid: string = null;
        public comtrbluemoonsessionid: string = null;
        public comtrbluemoonuserid: string = null;
        public comtrbluemooncontactid: string = null;
        public comtrbluemooncompanyid: string = null;
        public comtrbluemoondomain: string = null;

        public Time: Date = null;
        public Id: string = null;
        public Subject: string = null;
        public Source: string = null;

        public Type: string = null;
        public Specversion: string = null;
        public Datacontenttype: string = null;

        public Data: any = null;
    }

    export class ActiveSocketMsg {
        jobId: string;
        received: boolean = false;
    }

    export class FirmManagementReportsSocketService {

        private socketPath: string = null; // path to socketservices in the current environment
        public socket: WebSocket = null; // the web socket object representing the two way connection
        public socketSrvTracing: Map<string, ReportRequest> = new Map<string, ReportRequest>(); // queue of message strings to be sent
        public activeSocketMsg: ActiveSocketMsg = new ActiveSocketMsg();

        static $inject = ['$cookies'];

        public socketOk: boolean = false; // true if the socket is open and not in an error state
        public pendingSends = (): number => { // the number of messages waiting to be sent
            return this.socketSrvTracing.values.length;
        };

        // creates the path to the SocketService endpoint from the Angular environment config object
        constructor($cookies: any) {
            const token = $cookies.get('UDSLongToken');
            this.socketPath = location.hostname === 'localhost' ? `wss://demo.onvio.us/api/sockets/connect?token=${token}` :
                `wss://${location.hostname}/api/sockets/connect`;
        }

        // call this to open the web socket
        public init = (): void => {
            if (!this.socket) {
                this.connect(console.log);
            }
        }

        // call this to close the socket, for example in an onDestroy if used in a component
        public close = (): void => {
            if (this.socket) {
                this.socket.close();
            }
            this.clearCallbacks();
            this.clearErrorCallbacks();
        }

        // call this to register a function to receive the data string on message received
        public registerCallback = (func: any) => {
            this.callbacks.push(func);
        }

        public registerErrorCallbacks = (func: any) => {
            this.errorCallbacks.push(func);
        }

        // call this to clear all callback fucntions
        public clearCallbacks = () => {
            this.callbacks = new Array<any>();
        }

        // call this to clear all callback fucntions
        public clearErrorCallbacks = () => {
            this.errorCallbacks = new Array<any>();
        }

        // number of attempts to connect to the socket
        private connectionAttempts: number = 0;

        // private connect function, called on a callback to keep the socket open
        private connect = (callbackLog: any) => {
            ++this.connectionAttempts;

            var webSocket = new WebSocket(this.socketPath);

            webSocket.onopen = () => {
                this.socketOk = true; // notify the app we have an open socket
                this.sendLock = false; // unlock the send
                this.sendMessage(null); // start sending any queued message
            };

            webSocket.onerror = (ev: Event) => {
                try {
                    for (let func of this.errorCallbacks) {
                        try {
                            func(ev);
                        }
                        catch (err) {
                            console.error(err);
                        }
                    }
                }
                catch (exc) {
                    console.error(exc);
                }
            };

            webSocket.onclose = (ev: CloseEvent) => {
                this.socket = null;
                this.socketOk = false; // notify the app we have an open socket
                this.sendLock = true; // lock the send queue

            };

            webSocket.onmessage = (ev: MessageEvent) => {
                this.handleReceive(ev.data);
            };


            this.socket = webSocket;
        }

        // ----------------- //

        // registered callback functions to be called when messages are recevied
        public callbacks = new Array<any>();

        public errorCallbacks = new Array<any>();

        // called whenever a message is received and in trun invokes the callback functions
        private handleReceive = (data: string) => {
            try {
                for (let func of this.callbacks) {
                    try {
                        func(data);
                    }
                    catch (err) {
                        console.error(err);
                    }
                }
            }
            catch (exc) {
                console.error(exc);
            }
        };

        // indicates we are pending sends
        private sendLock: boolean = true; // send queue starts out locked while we await connection

          // queue of message strings to be sent
        private sendQueue = new Array<string>(); // array of messages waiting to be se

        // call this to send a message over the web socket
        public sendMessage = (message: string): void => {
            if (this.sendLock) {
                if (message != null)
                  this.sendQueue.push(message);
              }
              else {
                try {
                  this.sendLock = true;
                  if (message != null)
                    this.sendQueue.push(message);

                  while (this.sendQueue.length) {
                    var tosend: string = this.sendQueue.pop()
                    this.socket.send(tosend);
                  }
                }
                catch (exc) {
                  // should be opened in error pop-up in latter stories
                  console.error(exc);
                }
                finally {
                  this.sendLock = false;
                }
              }
        }
    }

    angular.module('onvio.reports.firmManagementReports.FirmManagementReportsSocketService',
        ['ngCookies'])
        .service('onvio.reports.firmManagementReports.FirmManagementReportsSocketService',
            FirmManagementReportsSocketService);
}
